var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { combine } from 'zustand/middleware';
export var customActions = function (initialValues) {
    return combine(initialValues, function (setState, _getState) { return ({
        addToast: function (value) {
            setState(function (state) {
                var id = Date.now();
                state.content.data = __spreadArray(__spreadArray([], state.content.data, true), [__assign(__assign({}, value), { id: id })], false);
                state.content.lastToastId = id;
                return { content: __assign({}, state.content) };
            });
        },
        addErrorToast: function (value) {
            setState(function (state) {
                var id = Date.now();
                state.content.data = __spreadArray(__spreadArray([], state.content.data, true), [__assign(__assign({}, value), { type: 'error', id: id })], false);
                state.content.lastToastId = id;
                return { content: __assign({}, state.content) };
            });
        },
        addSuccessToast: function (value) {
            setState(function (state) {
                var id = Date.now();
                state.content.data = __spreadArray(__spreadArray([], state.content.data, true), [__assign(__assign({}, value), { type: 'success', id: id })], false);
                state.content.lastToastId = id;
                return { content: __assign({}, state.content) };
            });
        },
        removeToast: function (value) {
            setState(function (state) {
                state.content.data = state.content.data.filter(function (item) { return item.id !== value; });
                if (!state.content.data.length) {
                    state.content.lastToastId = null;
                }
                return { content: __assign({}, state.content) };
            });
        },
    }); });
};
